import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

window.addEventListener('load', () => {
    handleSwiperInit();
});

window.addEventListener('resize', () => {
});

function handleSwiperInit() {
    const blocks = document.querySelectorAll('.hero-slider-block');

    blocks.forEach((block) => {
        const container = block.querySelector('.swiper');
        if (!container) return;

        const swiper = new Swiper(container, {
            modules: [Navigation, Pagination, Autoplay],
            spaceBetween: 0,
            loop: true,
            // autoplay: {
            //     delay: 3000,
            //     disableOnInteraction: false,
            // },
            slidesPerView: 1,
            navigation: {
                nextEl: block.querySelector('.swiper-button-next'),
                prevEl: block.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: block.querySelector('.swiper-pagination'),
                clickable: true,
            },
        });

        swiper;
    });
}